import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.neutralW20};
  padding: 16px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100svh;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  z-index: 100;
`

export const AlbumArtLarge = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
  margin-bottom: 16px;
  object-fit: cover;
  aspect-ratio: 1 / 1;
`

export const TrackInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export const TrackName = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 4px;
  padding-right: 10px;
  color: ${({ theme }) => theme.colors.neutralW100};
`

export const ArtistName = styled.p`
  font-size: 14px;
  padding-right: 10px;
  color: ${({ theme }) => theme.colors.neutralW70};
  margin-bottom: 20px;
`

export const PlayButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
`

export const PlaybackControls = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
`

export const TimeRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const Time = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutralW100};
`

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
`

export const ToggleContainer = styled.div`
  display: flex;
  align-self: center;
  position: relative;
  top: -4px;
  align-items: center;
  justify-content: center;

  input:checked + label {
    &:after {
      width: 24px !important;
      height: 24px !important;
      margin-left: 30px !important;
    }

    div {
      left: 30px !important;
      top: 4px;
      width: 23px !important;
      height: 23px !important;
    }
  }

  label {
    &:after {
      width: 24px;
      height: 24px;
    }

    div {
      left: 3px !important;
      top: 4px;
      width: 23px !important;
      height: 23px !important;
    }
  }

  svg {
    width: 23px !important;
    height: 23px !important;
  }
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const IconWrapper = styled.button`
  display: flex;
  padding: 4px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.neutralW20};
  cursor: ${({ $hasNoSong }) => ($hasNoSong ? 'default' : 'pointer')};
  transition: background-color 0.25s, border-color 0.25s;

  svg {
    width: 32px;
    height: 32px;
  }

  ${({ $hasNoSong, theme }) =>
    !$hasNoSong &&
    `
      &:hover {
        background-color: ${theme.colors.neutralW30}; 
      }
    `}

  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.colors.interact70};
  }
`
